import CloseIcon from "@mui/icons-material/Close";
import CommentIcon from "@mui/icons-material/Comment";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import {
  Backdrop,
  Badge,
  Card,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Switch,
  Tooltip,
} from "@mui/material";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Prompt from "components/UpStyled/Prompt";
import { AccountContext } from "context/account";
import { nanoid } from "nanoid";
import NewSharedBar from "pages/de/share-page/newsharebar";
import CreateSizeChartModal from "pages/de/size-chart/components/CreateSizeChartModal";
import Sketch, {
  AnnotationColors,
  AnnotationMethods,
  EditComments,
  SketchToolTip,
} from "pages/de/styles/detail/components/DevelopStage/Sketch";
import { useContext, useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import api from "services/api";
import { getImageDimensions } from "utils/imageHelper";
import SizeTable from "./sizetable";

var deepEqual = require("deep-equal");
const smartdate = require("smartdate");
smartdate.init();

var defaultFields = [
  { field: "id", headerName: "___id___", hide: true, disableReorder: true },
  { field: "Size", headerName: "Size", hide: false, width: 150, editable: true },
];

const SizeChartDetail = ({ sharedView = false }) => {
  const params = useParams();
  var id = params?.id;
  const navigate = useNavigate();
  const account = useContext(AccountContext);
  var user_id = account.id;
  var detail = { id: id, user_id: user_id };

  const [name, setName] = useState("");
  const [sketchDatas, setSketchDatas] = useState([]);
  const [tables, setTables] = useState([]);
  const [sketchComments, setSketchComments] = useState({});
  const [sketchHeight, setSketchHeight] = useState(400);
  const [color, setColor] = useState("Black");
  const [method, setMethod] = useState(null);
  const [isDragDisabled, setIsDragDisabled] = useState(true);
  const [deleteImgDialogVisible, setDeleteImgDialogVisible] = useState(false);
  const [deleteImage, setDeleteImage] = useState(null);
  const [showComments, setShowComments] = useState(false);
  const [currentAnnot, setCurrentAnnot] = useState(null);
  const [imageFilter, setImageFilter] = useState("");
  const [commentsDialogVisible, setCommentsDialogVisible] = useState(false);
  const [stepHistoryIndex, setStepHistoryIndex] = useState(false);
  const [sizeChartData, setSizeChartData] = useState({});
  const [editNameVisible, setEditNameVisible] = useState(false);
  const [inputWidth, setInputWidth] = useState(20);
  const [editSizeChartVisible, setEditSizeChartVisible] = useState(false);
  const [editmode, setEditmode] = useState(0);
  const [ownerId, setOwnerId] = useState(null);
  const [uploading, setUploading] = useState(false);

  const sketchTooltipRef = useRef(null);
  const stepHistory = useRef([{ sketchDatas: sketchDatas, tables: tables }]);
  const stepHistoryCheck = useRef(1);
  const stepHistoryIndexRef = useRef();
  stepHistoryIndexRef.current = stepHistoryIndex;
  const boardRef = useRef(null);
  const styleNameInputRef = useRef(null);

  const setSketchToolTip = (tooltip) => {
    if (sketchTooltipRef.current) sketchTooltipRef.current.setSketchToolTip2(tooltip);
  };

  const refreshComments = () => {
    if (sketchDatas.length == 0) {
      setShowComments(false);
      return;
    }
    var sketchids = sketchDatas.map((s) => s.id);
    try {
      api.comment.sketch_get({ sketchids: sketchids, product_id: id }).then(({ data }) => {
        const newSketchComments = {};
        for (var sketchcomment of data.sketchcomments) {
          sketchcomment.startX = sketchcomment.metadata.startX ?? NaN;
          sketchcomment.startY = sketchcomment.metadata.startY ?? NaN;
          sketchcomment.endX = sketchcomment.metadata.endX;
          sketchcomment.endY = sketchcomment.metadata.endY;
          sketchcomment.color = sketchcomment.metadata.color;
          sketchcomment.index = sketchcomment.metadata.index;
          sketchcomment.method = "comments";
          sketchcomment.newcomments =
            sketchcomment.latestcommentts &&
            sketchcomment.latestcommentts > (sketchcomment.viewcommentts[user_id] ?? "");
          if (!(sketchcomment.sketch_id in newSketchComments))
            newSketchComments[sketchcomment.sketch_id] = [];
          newSketchComments[sketchcomment.sketch_id].push(sketchcomment);
        }
        setSketchComments(newSketchComments);
        setShowComments(data.sketchcomments.length > 0);
        //console.log('newSketchComments', newSketchComments)
        return data;
      });
    } catch (err) {
      toast.error("load sketch comments failed!");
      console.log(err);
    }
  };

  const unDo = () => {
    if (stepHistoryIndexRef.current <= 0) return;
    setStepHistoryIndex(stepHistoryIndexRef.current - 1);
    stepHistoryCheck.current = 2;
    setSketchDatas(stepHistory.current[stepHistoryIndexRef.current - 1].sketchDatas);
    setTables(stepHistory.current[stepHistoryIndexRef.current - 1].tables);
  };

  const reDo = () => {
    if (stepHistoryIndexRef.current >= stepHistory.current.length - 1) return;
    setStepHistoryIndex(stepHistoryIndexRef.current + 1);
    stepHistoryCheck.current = 2;
    setSketchDatas(stepHistory.current[stepHistoryIndexRef.current + 1].sketchDatas);
    setTables(stepHistory.current[stepHistoryIndexRef.current + 1].tables);
  };

  function KeyPress(e) {
    var evtobj = window.event ? window.event : e;
    //console.log('evtobj', evtobj)
    var code = evtobj.keyCode || evtobj.which;
    if ((code == 90 || code == 122) && (evtobj.metaKey || evtobj.ctrlKey)) {
      console.log(evtobj.shiftKey ? "Redo" : "Undo");
      if (evtobj.shiftKey) reDo();
      else unDo();
    }
  }

  useEffect(() => {
    document.onkeydown = KeyPress;
    return () => {
      document.onkeydown = undefined;
    };
  }, []);

  useEffect(() => {
    if (id) {
      retrieveSizeChart();
      refreshComments();
    }
  }, [id]);

  useEffect(() => {
    refreshComments();
  }, [sketchDatas]);

  useEffect(() => {
    setEditmode(account?.id === ownerId ? 1 : 0);
    setMethod(account?.id === ownerId ? "end" : "comments");
  }, [ownerId, account?.id]);

  const retrieveSizeChart = async () => {
    try {
      const { data } = await api.sizeChart.retrieve(id);

      var defaultFields = [
        { field: "id", headerName: "___id___", hide: true, disableReorder: true },
        { field: "Size", headerName: "Size", hide: false, width: 150, editable: true },
      ];
      boardRef.current = data.size?.metadata;
      if (!boardRef.current) {
        var initfields = [...defaultFields];
        var sizeArr = data.size?.sizes?.split(",") || [];
        for (var size of sizeArr) {
          size = size.trim();
          if (size !== "")
            initfields.push({
              field: nanoid(),
              headerName: size,
              hide: false,
              width: 100,
              editable: true,
            });
        }
        boardRef.current = {
          sketchdatas: [],
          tables: [{ id: nanoid(), rows: [], fields: initfields }],
        };
      }
      setName(data.size?.name);
      setSketchDatas(boardRef.current.sketchdatas);
      setTables(boardRef.current.tables);
      setSizeChartData(data?.size || {});
      setOwnerId(data.size?.owner_id);
      stepHistoryCheck.current = 0;
      stepHistory.current = [
        { sketchDatas: boardRef.current.sketchdatas, tables: boardRef.current.tables },
      ];
      //console.log("data", data, "boardRef.current", boardRef.current);
    } catch (err) {
      toast.error(`Retrieve sizeChart failed!`);
      console.log(err);
    }
  };

  const getColumnStr = () => {
    if (tables.length == 0) return null;
    var strlist = [];
    for (var index = 2; index < tables[0].fields.length; ++index) {
      if (
        tables[0].fields[index].headerName !== "" &&
        tables[0].fields[index].headerName !== "Size" &&
        tables[0].fields[index].headerName !== "Code" &&
        !strlist.find((str) => str === tables[0].fields[index].headerName)
      )
        strlist.push(tables[0].fields[index].headerName);
    }
    var result = "";
    for (var str of strlist) result += str + ",";
    if (result !== "") result = result.substring(0, result.length - 1);
    return result;
  };

  useEffect(() => {
    //console.log("boardRef.current", stepHistoryCheck.current, boardRef.current, sketchDatas);
    if (stepHistoryCheck.current > 0) {
      if (
        boardRef.current &&
        (!deepEqual(boardRef.current.sketchdatas, sketchDatas) ||
          !deepEqual(boardRef.current.tables, tables))
      ) {
        boardRef.current.sketchdatas = sketchDatas;
        boardRef.current.tables = tables;
        if (stepHistoryCheck.current === 1) {
          if (stepHistoryIndex + 1 < stepHistory.current.length)
            stepHistory.current.splice(stepHistoryIndex + 1);
          stepHistory.current.push({ sketchDatas: sketchDatas, tables: tables });
          setStepHistoryIndex(stepHistoryIndex + 1);
          //console.log('stepHistory.current', stepHistory.current)
        }
        //console.log('update', boardRef.current)
        api.sizeChart
          .update(id, { metadata: boardRef.current, sizes: getColumnStr() })
          .then(({ data }) => {});
      }
    }
    stepHistoryCheck.current = 1;
  }, [sketchDatas, tables]);

  const updateTable = (tableId, rows, fields) => {
    const nextDatas = tables.map((t) => {
      if (t.id === tableId) {
        return { ...t, rows: rows, fields: fields };
      } else {
        return t;
      }
    });
    setTables(nextDatas);
  };

  const deleteTable = (tableId) => {
    const nextDatas = tables.filter((t) => t.id !== tableId);
    setTables(nextDatas);
  };

  const handleUpload = async ({ file }) => {
    setUploading(true);
    var rid = nanoid();
    //console.log('file', file)
    var file2 = new File([file], rid + "_" + file.name, { type: file.type });
    const url = await api.uploads.create([file2]).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    if (url && url.length == 1) {
      try {
        const { width, height } = await getImageDimensions(url);
        setSketchDatas((oldData) => [
          ...oldData,
          {
            id: rid,
            name: file.name,
            type: file.type,
            imgurl: url,
            height: height,
            width: width,
            lines: [],
          },
        ]);
        setImageFilter("");
      } catch (err) {
        console.log(err);
        toast.error("File can not be processed due to incompatible format!");
      }
    }
    setUploading(false);
  };

  const updateImageRatio = (id, imgRatio, recordhistory) => {
    const nextSketchDatas = sketchDatas.map((s) => {
      if (s.id === id) {
        return { ...s, imgRatio: imgRatio };
      } else {
        return s;
      }
    });
    stepHistoryCheck.current = recordhistory ? 1 : 2;
    setSketchDatas(nextSketchDatas);
  };

  const updateRotation = (id, rotation) => {
    const nextSketchDatas = sketchDatas.map((s) => {
      if (s.id === id) {
        return { ...s, rotation: rotation };
      } else {
        return s;
      }
    });
    stepHistoryCheck.current = 1;
    setSketchDatas(nextSketchDatas);
  };

  const updateLine = (line) => {
    var sketchdata = findLine(line.id).sketchdata;
    const nextLines = sketchdata.lines.map((l) => {
      if (l.id === line.id) {
        return line;
      } else {
        return l;
      }
    });
    updateLines(sketchdata.id, [...nextLines]);
  };

  const deleteLine = (line, collaborationDelete = false) => {
    var sketchdata = findLine(line.id).sketchdata;
    const nextLines = sketchdata.lines.filter((l) => l.id !== line.id);
    updateLines(sketchdata.id, [...nextLines]);
  };

  const updateLines = (id, lines) => {
    var nextSketchDatas = sketchDatas.map((s) => {
      if (s.id === id) {
        return { ...s, lines: lines };
      } else {
        return s;
      }
    });
    setSketchDatas(nextSketchDatas);
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...sketchDatas];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    setSketchDatas(updatedList);
  };

  const getNextIntIndex = () => {
    var maxIndex = 0;
    for (var sketchdata of sketchDatas) {
      for (var l of sketchdata.lines) maxIndex = Math.max(maxIndex, l.index);
    }
    return maxIndex + 1;
  };

  const getNextIndex = () => {
    var indexArray = [];
    if (method == "comments") {
      for (var sketchdata of sketchDatas) {
        if (sketchdata.id in sketchComments) {
          for (var c of sketchComments[sketchdata.id]) indexArray.push(c.index);
        }
      }
      var commentindex = 0;
      while (indexArray.includes(String.fromCharCode(65 + commentindex))) {
        commentindex += 1;
      }
      return String.fromCharCode(65 + commentindex++);
    } else {
      return getNextIntIndex();
    }
  };

  var filteredSketchDatas = [];
  var commentsList = [];
  if (sketchDatas) {
    var sketchid = 0;
    for (var sketchdata of sketchDatas) {
      sketchdata.charid = String.fromCharCode(65 + sketchid++);
    }
    filteredSketchDatas = sketchDatas.filter(
      (sketchdata) => imageFilter == "" || sketchdata.id == imageFilter
    );
    for (const sketchdata of filteredSketchDatas) {
      if (sketchdata.id in sketchComments) {
        commentsList = commentsList.concat(sketchComments[sketchdata.id]);
      }
    }
    commentsList.sort((a, b) => (a.index < b.index ? -1 : 1));
  }

  //console.log('stepHistoryIndex', stepHistoryIndex, 'stepHistory.current', stepHistory.current)
  const smartdate = require("smartdate");
  smartdate.init();

  const handleChangeStyleName = async () => {
    let value = styleNameInputRef?.current?.value;
    value = value.trim();
    if (value == sizeChartData?.name || !value) {
      setEditNameVisible(false);
      return;
    }
    try {
      await api.sizeChart.update(sizeChartData.id, { name: value });
      retrieveSizeChart();
      toast.success("Update size chart name successfully!");
    } catch (err) {
      console.log(err);
      toast.error("Update size chart name failed!");
    }
    setEditNameVisible(false);
  };

  const handleShowEditStyleName = () => {
    setEditNameVisible(true);
    setInputWidth(sizeChartData?.name?.length);
  };

  const isOwner = account?.id == sizeChartData?.owner_id;

  const handleDuplicateSizeChart = async (data = {}) => {
    try {
      const payload = {
        name: "Duplicate of " + sizeChartData["name"],
        sizes: sizeChartData["sizes"],
        gender: sizeChartData["gender"],
        category: sizeChartData["category"],
        class: sizeChartData["class"],
        attribute: sizeChartData["attribute"],
        metadata: sizeChartData["metadata"],
      };

      const newCreatedSizeChart = await api.sizeChart.create(payload);
      toast.success(`${payload["name"]} has been duplicated successfully!`);
      navigate(`/setup/size-master`);
    } catch (err) {
      console.log(err);
      toast.error(`Size Chart could not be duplicated!`);
      setUploading(false);
    }
  };

  return (
    <div>
      <NewSharedBar
        type="size_chart"
        data={sizeChartData}
        shareSessionRef={null}
        handleRefreshSourceData={retrieveSizeChart}
        ActionGroup={
          account.role == "admin" ? null : account.account_type == "de" ? (
            <div>
              <Tooltip title="Duplicate to my size master">
                <SuiButton
                  onClick={() => handleDuplicateSizeChart()}
                  color="dark"
                  sx={{
                    padding: "0px 8px",
                    fontSize: 12,
                    lineHeight: 0,
                    minHeight: 25,
                    minWidth: 25,
                    textTransform: "none",
                    borderRadius: "4px",
                  }}
                  size="small"
                >
                  {" "}
                  Duplicate
                </SuiButton>
              </Tooltip>
            </div>
          ) : (
            <div />
          )
        }
        title={
          <SuiBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ height: "100%" }}
          >
            {editNameVisible ? (
              <div className="flex">
                <input
                  size="small"
                  defaultValue={sizeChartData.name}
                  ref={styleNameInputRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleChangeStyleName();
                    }
                  }}
                  className="font-serif"
                  autoFocus
                  style={{
                    outline: "none",
                    border: "none",
                    width: inputWidth + "ch",
                    fontSize: "1.25rem",
                    lineHeight: 1.375,
                    fontWeight: 700,
                  }}
                  onChange={(e) => setInputWidth(e.target?.value?.length)}
                  onBlur={handleChangeStyleName}
                />
              </div>
            ) : (
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                <Tooltip title={isOwner ? "Click to change name" : ""}>
                  <SuiTypography
                    variant="h5"
                    className="font-serif"
                    fontWeight="bold"
                    textTransform="none"
                    onClick={() => (isOwner ? handleShowEditStyleName() : null)}
                  >
                    {sizeChartData.name}
                  </SuiTypography>
                </Tooltip>
                {isOwner ? (
                  <Tooltip title={isOwner ? "Click to Edit" : ""}>
                    <EditIcon
                      sx={{ cursor: "pointer" }}
                      fontSize={"small"}
                      onClick={() => setEditSizeChartVisible(true)}
                    />
                  </Tooltip>
                ) : null}
              </SuiBox>
            )}
          </SuiBox>
        }
      />
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          Uploading supporting files...
        </SuiTypography>
      </Backdrop>
      <Card sx={{ p: 1, height: "100%", width: "100%" }}>
        <Prompt
          heading="Delete Confirmation"
          text={`Are you sure you want to delete this image?`}
          visible={deleteImgDialogVisible}
          okText="Delete"
          okColor="dark"
          handleOk={() => {
            setDeleteImgDialogVisible(false);
            var newSketchDatas = sketchDatas.filter((s) => s.id !== deleteImage);
            setSketchDatas(newSketchDatas);
            setIsDragDisabled(true);
            setImageFilter("");
          }}
          handleClose={() => setDeleteImgDialogVisible(false)}
        />
        <SuiBox sx={{ mb: 0, flexWrap: "wrap" }} display="flex" alignItems="center">
          {editmode > 0 && (
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <AnnotationMethods color={color} method={method} setMethod={setMethod} />
            </SuiBox>
          )}
          {
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <AnnotationColors color={color} setColor={setColor} />
            </SuiBox>
          }
          {
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <Tooltip title={`Add comments on top of image`} placement="top-start">
                <IconButton
                  sx={{ mx: 0 }}
                  size="inherit"
                  style={method == "comments" ? { backgroundColor: "LightGrey" } : {}}
                  onClick={() => {
                    setMethod("comments");
                    setShowComments(true);
                  }}
                >
                  <CommentIcon
                    fontSize="inherit"
                    style={{ color: color }}
                    className="border-none hover:bg-transparent"
                  />
                </IconButton>
              </Tooltip>
              <SuiButton
                sx={{ mx: 0, my: 0, p: 0, textTransform: "none" }}
                color="dark"
                variant="text"
                onClick={(e) => {
                  setMethod("comments");
                  setShowComments(true);
                }}
              >
                Add
                <br />
                Comments
              </SuiButton>
              <Switch
                sx={{ mx: 1 }}
                checked={showComments}
                onChange={() => setShowComments(!showComments)}
              />
              <SuiButton
                sx={{ mx: 0, my: 0, p: 0, textTransform: "none" }}
                color="dark"
                variant="text"
                onClick={(e) => {
                  setShowComments(!showComments);
                }}
              >
                {showComments ? "Hide" : "Show"}
                <br />
                Comments
              </SuiButton>
            </SuiBox>
          }
          <SuiBox
            sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
            display="flex"
            alignItems="center"
          >
            <Tooltip
              title={`Increase image height from ${sketchHeight} to ${sketchHeight + 100} pixels`}
              placement="top-start"
            >
              <IconButton
                sx={{ mx: 0 }}
                size="medium"
                onClick={() => {
                  setSketchHeight(sketchHeight + 100);
                }}
              >
                <ZoomInIcon
                  fontSize="medium"
                  color="inherit"
                  className="border-none hover:bg-transparent"
                />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={`Decrease image height from ${sketchHeight} to ${
                sketchHeight > 100 ? sketchHeight - 100 : sketchHeight
              } pixels`}
              placement="top-start"
            >
              <IconButton
                sx={{ mx: 0 }}
                size="medium"
                onClick={() => {
                  if (sketchHeight > 100) setSketchHeight(sketchHeight - 100);
                }}
              >
                <ZoomOutIcon
                  fontSize="medium"
                  color="inherit"
                  className="border-none hover:bg-transparent"
                />
              </IconButton>
            </Tooltip>
          </SuiBox>
          {editmode > 0 && (
            <SuiBox
              sx={{ pr: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <Tooltip title={`Undo`} placement="top-start">
                <span>
                  <IconButton
                    sx={{ mx: 0 }}
                    disabled={stepHistoryIndex <= 0}
                    size="medium"
                    onClick={() => {
                      unDo();
                    }}
                  >
                    <Icon
                      fontSize="medium"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    >
                      undo
                    </Icon>
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={`Redo`} placement="top-start">
                <span>
                  <IconButton
                    sx={{ mx: 0 }}
                    disabled={stepHistoryIndex >= stepHistory.current.length - 1}
                    size="medium"
                    onClick={() => {
                      reDo();
                    }}
                  >
                    <Icon
                      fontSize="medium"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    >
                      redo
                    </Icon>
                  </IconButton>
                </span>
              </Tooltip>
            </SuiBox>
          )}
        </SuiBox>
        {sketchDatas?.length === 0 && (
          <SuiTypography sx={{ mt: 2 }} variant="h6">
            {editmode
              ? `Please click "Upload/Drop Images" button to upload image files or drag and drop image files to below area.`
              : "No uploaded image files."}
          </SuiTypography>
        )}
        <Grid container spacing={2} sx={{ pt: 5 }}>
          <Grid item xs={12} sm={showComments ? 8 : 12} md={showComments ? 8 : 12}>
            <SuiBox
              className="flex flex-row"
              sx={{ width: "100%" }}
              style={{ overflowX: "auto", overflowY: "hidden" }}
            >
              <DragDropContext onDragEnd={handleDrop}>
                <Droppable droppableId="list-container" direction="horizontal">
                  {(provided) => (
                    <div
                      style={{ display: "flex", alignItems: "start" }}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {filteredSketchDatas.map((sketchdata, index) => (
                        <Draggable
                          key={sketchdata.id}
                          draggableId={sketchdata.id}
                          index={index}
                          isDragDisabled={isDragDisabled || !editmode}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.dragHandleProps}
                              {...provided.draggableProps}
                              style={{
                                minWidth:
                                  ((sketchHeight * sketchdata.width) / sketchdata.height) *
                                  (sketchdata.imgRatio ?? 1),
                              }}
                            >
                              <Sketch
                                detail={detail}
                                board={boardRef.current}
                                editmode={editmode}
                                sketchdata={sketchdata}
                                sketchcomments={sketchComments[sketchdata.id]}
                                sketchHeight={sketchHeight}
                                color={color}
                                method={method}
                                updateLines={updateLines}
                                refreshComments={refreshComments}
                                updateImageRatio={updateImageRatio}
                                updateRotation={updateRotation}
                                setIsDragDisabled={setIsDragDisabled}
                                setImageFilter={setImageFilter}
                                setDeleteImage={setDeleteImage}
                                setDeleteImgDialogVisible={setDeleteImgDialogVisible}
                                sketchDatas={sketchDatas}
                                imageFilter={imageFilter}
                                showComments={showComments}
                                setSketchToolTip={setSketchToolTip}
                                getNextIndex={getNextIndex}
                                addCollaborationHistory={null}
                              />
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                      {editmode > 0 && (
                        <div
                          onDrop={async (e) => {
                            e.preventDefault();
                            for (var file of e.dataTransfer?.files) {
                              await handleUpload({ file });
                            }
                          }}
                          onDragOver={(e) => e.preventDefault()}
                        >
                          <Card
                            sx={{
                              width: "200px",
                              height: filteredSketchDatas.length > 0 ? sketchHeight + 37 : 200,
                            }}
                          >
                            <SuiBox
                              sx={{ width: "100%", height: "100%" }}
                              className="flex items-center justify-center"
                            >
                              <Upload
                                accept="image/*"
                                multiple
                                showUploadList={false}
                                customRequest={handleUpload}
                              >
                                <SuiButton
                                  sx={{ mx: 0, p: 0, textTransform: "none" }}
                                  size="medium"
                                  variant="text"
                                  color="dark"
                                  startIcon={<UploadIcon fontSize="large" />}
                                >
                                  Upload/Drop Images
                                </SuiButton>
                              </Upload>
                            </SuiBox>
                          </Card>
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </SuiBox>
          </Grid>
          {showComments && (
            <Grid item xs={12} sm={4} md={4}>
              <Card sx={{ borderRadius: 2 }}>
                <EditComments
                  comments={currentAnnot}
                  commentsDialogVisible={commentsDialogVisible}
                  setCommentsDialogVisible={setCommentsDialogVisible}
                  refreshComments={refreshComments}
                  detail={detail}
                  board={boardRef.current}
                />
                <SuiBox sx={{ height: sketchHeight + 37 }}>
                  <SuiBox
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    alignItems="center"
                  >
                    <SuiTypography variant="h6" sx={{ ml: 1 }}>
                      Comments:
                    </SuiTypography>
                    <IconButton
                      aria-label="close"
                      onClick={() => setShowComments(false)}
                      sx={{
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </SuiBox>
                  <ul style={{ overflowY: "auto", maxHeight: sketchHeight }}>
                    {commentsList.length == 0 && (
                      <SuiTypography variant="caption" sx={{ m: 1 }}>
                        Tips: select "Add Comments" and click on image to create a new Comment entry
                      </SuiTypography>
                    )}
                    {commentsList.map((sc) => (
                      <SuiBox key={sc.index} sx={{ m: 1 }}>
                        <a
                          onClick={() => {
                            setCurrentAnnot(sc);
                            setCommentsDialogVisible(true);
                          }}
                        >
                          <SuiTypography variant="button" className={`block text-gray-600`}>
                            #{sc.index}
                          </SuiTypography>
                          <SuiBox display="flex" justifyContent="center" alignItems="center">
                            <Badge variant="dot" color="error" invisible={!sc.newcomments}>
                              <ContactAvatar room={sc} />
                            </Badge>
                            <div className="w-full pb-2 ml-1">
                              <div className="flex justify-between items-center">
                                <SuiTypography
                                  className={`text-gray-600`}
                                  variant="body1"
                                  textTransform="none"
                                  sx={{
                                    width: "100%",
                                    minHeight: "16px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: "1",
                                    WebkitBoxOrient: "vertical",
                                  }}
                                >
                                  {sc.content ?? " "}
                                </SuiTypography>
                              </div>
                              <div className="flex justify-between items-center">
                                <SuiTypography variant="caption">
                                  {sc.commentCnts ?? 0} Comments
                                </SuiTypography>
                                <SuiTypography variant="caption">
                                  {smartdate.format(new Date(sc.timestamp))}
                                </SuiTypography>
                              </div>
                            </div>
                          </SuiBox>
                        </a>
                      </SuiBox>
                    ))}
                  </ul>
                </SuiBox>
              </Card>
            </Grid>
          )}
        </Grid>
        {false && (
          <SuiBox className="flex flex-row" sx={{ width: "100%" }}>
            {sketchDatas?.length > 0 && (
              <SketchToolTip ref={sketchTooltipRef} color={color} method={method} />
            )}
          </SuiBox>
        )}
        {tables.map((table) => (
          <SizeTable
            key={table.id}
            editmode={editmode}
            table={table}
            updateTable={updateTable}
            deleteTable={deleteTable}
            name={name}
          />
        ))}
        {editmode > 0 && (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mt={5}
            mb={2}
            mr={1}
          >
            <SuiButton
              variant="gradient"
              color={"dark"}
              onClick={() => {
                setTables([...tables, { id: nanoid(), rows: [], fields: defaultFields }]);
              }}
            >
              Create New Size Table
            </SuiButton>
          </SuiBox>
        )}
      </Card>
      {editSizeChartVisible ? (
        <CreateSizeChartModal
          handleClose={() => setEditSizeChartVisible(false)}
          visible={editSizeChartVisible}
          isEdit={true}
          handleRefresh={retrieveSizeChart}
          sizeChart={sizeChartData}
        />
      ) : null}
    </div>
  );
};

export default SizeChartDetail;
